import React, { useContext } from "react";
import { theme } from "../theme";
import Current from "../components/Current";
import Criteria from "../components/Criteria";
import { General } from "../tools/styles";
import Generic from "../components/Generic";
import RenderIf from "../components/RenderIf"
import {WatchContext} from '../WatchContext'
import handleInputChange from "../tools/handleInputChange";
import calcSedConcern from "../tools/calcSedConcern";
import calcSedComplete from "../tools/calcSedComplete";

const VertSed = () => {

  let {vertsed, setVertsed} = useContext(WatchContext);

  const handleChange = ({ target }) => {

    let data = handleInputChange(vertsed, target)

    let concernedData = calcSedConcern(data)
  
    let completeData = calcSedComplete(concernedData)

    setVertsed(completeData);
  };

  return (
    <>
      <General.Heading color={theme.colors.pdeBlue}>
        {vertsed.title}
      </General.Heading>

      <Generic
        text={vertsed.metric}
        title='Metric'
      />
      <Generic
        text={vertsed.method}
        title='Method'
      />
      <Current
        currentValue={vertsed.currentValue}
        // valDesc="Positive (+) values denote waterward movement of edge
        //     Negative (-) values denote landward movement of edge."
        units={vertsed.units}
        just={vertsed.currentJust}
        handleChange={handleChange}

      />
      <Criteria
        low={vertsed.criteriaLow}
        high={vertsed.criteriaHigh}
        units={vertsed.units}
        type={vertsed.criteriaType}
        just={vertsed.criteriaJust}
        handleChange={handleChange}
      />
      <Generic
        align='center'
        title='Concerns'
        text={ <>
          <General.InputCont>
          <RenderIf isTrue={vertsed.currentConcern === 1}>
          <General.BoldPara>
              {vertsed.metric} currently falls outside the healthy range of values.
            </General.BoldPara>
        </RenderIf>
        <RenderIf isTrue={vertsed.currentConcern === 0}>
          
            <p>
              {vertsed.metric} currently falls within the healthy range of values.
            </p>
          
        </RenderIf>
        <RenderIf isTrue={vertsed.currentConcern === -1}>
          
            <p>
              Need more information.
            </p>
          
        </RenderIf>
          </General.InputCont>
        
        
        </>}
      />

    </>
  );
};

export default VertSed;
